import { param } from "./generated/labels";
import { isFunction } from "./utils/utils";

export type ParamKey = keyof typeof param

export interface IParam {
    value: number;
    text: string;
}

export function getParameters(name: ParamKey): IParam[] {

    var p = param[name];

    if (isFunction(p)) {
        return p();
    }

}
